<template>
  <div class="" style="color: #fff; background-color: #010c2a; height: 100%">
    <el-container>
      <el-dialog :center="true" title="选择园区" :visible.sync="dialogVisible" width="50%">
        <div class="dialog-content-body" style="display: flex; justify-content: center; width: 100%">
          <div v-if="parkList.length != 0" class="" style="width: 100%">
            <div class="dialog-content">
              <div style="width: 33%" class="" v-for="(item, index) in parkList" :key="index" @click="
                parkCurrent = index;
              parkId = item.massifId;
              ">
                <div style="padding: 0.9375rem; width: 85%; height: 200px" :class="parkCurrent == index
                  ? 'dialog-item-bg-sel'
                  : 'dialog-item-bg'
                  ">
                  <img :src="item.massifPic[0]"
                    style="width: 100%; height: 100%; border-radius: 0.3125rem;object-fit: cover;" alt="a" />
                </div>
                <div class="dialog-content-title">
                  {{ item.massifName }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="parkList.length == 0" style="
              color: #999;
              display: flex;
              align-items: center;
              justify-content: center;
            ">
            您还没有添加过园区！
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button type="info" @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleParkChange">确 定</el-button>
        </span>
      </el-dialog>

      <el-header style="height: 5.625rem">
        <div class="index-bg-img">
          <div class="" style="
              font-size: 28px;
              padding-top: 22px;
              font-weight: bold;
              color: #4affff;
            ">
            {{ userInfo ? userInfo.userName : "" }}大数据平台
          </div>
        </div>
        <div class="exit" @click="exitOnHandle">
          <span class="iconfont icon-tuichu" style="font-size: 1.25rem; margin-right: 0.3125rem"></span>退出登录
        </div>
      </el-header>
      <el-main style="
          padding-top: 30px;
          background-color: #010c2a;
          background-image: url('https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1706071626127.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
        ">
        <el-row>
          <el-col :span="7">
            <div class="grid-content">
              <div>
                <div @click="nextClick(0)" v-if="powerInfo.powerWarmState == '0'">
                  <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700722424667.png"
                    style="width: 18.75rem; height: 18.75rem; cursor: pointer" alt="" />
                </div>
                <div class="tab-bg" v-if="powerInfo.powerWarmState == '0'">
                  <div class="tab-title">智能温室系统</div>
                </div>



                <div @click="nextClick(1)" v-if="powerInfo.powerWaterState == '0'">
                  <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700722557287.png"
                    style="width: 18.75rem; height: 18.75rem; cursor: pointer" alt="" />
                </div>
                <div class="tab-bg" v-if="powerInfo.powerWaterState == '0'">
                  <div class="tab-title">智慧灌溉系统</div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content" style="position: relative">
              <div class="content-center">
                <div class="content-center-left-right-icon">
                  <div>
                    <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700729025623.png" alt="" />
                  </div>
                  <div>
                    <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700729030270.png" alt="" />
                  </div>
                </div>
                <div class="content-center-header">
                  <div class="content-center-header-item" v-if="powerInfo.powerWarmState == '0'">
                    <div style="width: 100%; padding: 0.625rem 0.9375rem">
                      <div style="display: flex; align-items: center">
                        <img style="height: 0.625rem"
                          src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700730282871.png" alt="" />
                        <div>智能温室控制器</div>
                      </div>
                      <div class="content-center-header-item-title">
                        <div class="title1" style="color: #fff">
                          {{ warm.count }}
                        </div>
                        <div class="title1">{{ warm.down }}</div>
                        <div class="title1" style="color: #999">
                          {{ warm.up }}
                        </div>
                      </div>
                      <div class="content-center-header-item-title">
                        <div class="title2">设备总数</div>
                        <div class="title2">在线数</div>
                        <div class="title2">离线数</div>
                      </div>
                    </div>
                  </div>

                  <div class="content-center-header-item" v-if="powerInfo.powerWaterState == '0'">
                    <div style="width: 100%; padding: 0.625rem 0.9375rem">
                      <div style="display: flex; align-items: center">
                        <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700730277696.png" alt="" />
                        <div>水肥一体机</div>
                      </div>
                      <div class="content-center-header-item-title">
                        <div class="title1" style="color: #fff">
                          {{ water.count }}
                        </div>
                        <div class="title1">{{ water.up }}</div>
                        <div class="title1" style="color: #999">
                          {{ water.down }}
                        </div>
                      </div>
                      <div class="content-center-header-item-title">
                        <div class="title2">设备总数</div>
                        <div class="title2">在线数</div>
                        <div class="title2">离线数</div>
                      </div>
                    </div>
                  </div>

                  <div class="content-center-header-item">
                    <div style="width: 100%; padding: 0.625rem 0.9375rem">
                      <div style="display: flex; align-items: center">
                        <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700730273579.png" alt="" />
                        <div>五情监测设备</div>
                      </div>
                      <div class="content-center-header-item-title">
                        <div class="title1" style="color: #fff; width: 100%; text-align: center">
                          {{ fiveEmotions.count }}
                        </div>
                        <!-- <div class="title1">{{ fiveEmotions.up }}</div>
												<div class="title1" style="color: #999">
													{{ fiveEmotions.down }}
												</div> -->
                      </div>
                      <div class="content-center-header-item-title">
                        <div class="title2" style="width: 100%; text-align: center">
                          设备总数
                        </div>
                        <!-- <div class="title2">在线数</div>
												<div class="title2">离线数</div> -->
                      </div>
                    </div>
                  </div>
                </div>

                <div class="content-center-body">
                  <div>
                    <div class="content-center-body-left-right-img">
                      <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700731714298.png" alt="" />
                    </div>
                    <div class="content-center-body-left-right-img">
                      <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700731714298.png" alt="" />
                    </div>
                  </div>
                  <div class="content-center-body-center-img">
                    <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700732986024.png" alt="" />
                  </div>
                  <div>
                    <div class="content-center-body-left-right-img">
                      <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700731719641.png" alt="" />
                    </div>
                    <div class="content-center-body-left-right-img">
                      <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700731719641.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="content-center-body-flex"></div>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="grid-content">
              <div>

                <div @click="nextClick(2)">
                  <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700725264795.png"
                    style="width: 18.75rem; height: 18.75rem; cursor: pointer" alt="" />
                </div>
                <div class="tab-bg">
                  <div class="tab-title">五情检测系统</div>
                </div>

                <div @click="nextClick(3)">
                  <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700725269285.png"
                    style="width: 18.75rem; height: 18.75rem; cursor: pointer" alt="" />
                </div>
                <div class="tab-bg">
                  <div class="tab-title">农业溯源系统</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  data() {
    return {
      title: "甘肃智慧农业大数据平台",
      current: 0,
      parkList: [
        {
          id: "1",
          name: "武威市凉州区1号示范园",
        },
        {
          id: "2",
          name: "武威市凉州区2号示范园",
        },
      ],
      parkId: null, //温室水肥设备选择园区
      dialogVisible: false,
      parkCurrent: null,
      userInfo: null,
      warm: {
        up: 0,
        down: 0,
        count: 0,
      },
      water: {
        up: 0,
        down: 0,
        count: 0,
      },
      fiveEmotions: {
        up: 0,
        down: 0,
        count: 0,
      },
      powerInfo: {
        powerWarmRegion1: "0006",
        powerWarmRegion1Name: "温湿度",
        powerWarmRegion1Unit: "℃,%RH",
        powerWarmRegion2: "0004",
        powerWarmRegion2Name: "二氧化碳",
        powerWarmRegion2Unit: "PPM",
        powerWarmRegion3: "0004",
        powerWarmRegion3Name: "光照度",
        powerWarmRegion3Unit: "Lux",
        powerWarmState: "0",
        powerWaterRegion1: "0010",
        powerWaterRegion1Name: "温度,湿度",
        powerWaterRegion1Unit: "℃,%RH",
        powerWaterRegion2: "0010",
        powerWaterRegion2Name: "EC值",
        powerWaterRegion2Unit: "µS/cm",
        powerWaterRegion3: "0010",
        powerWaterRegion3Name: "PH值",
        powerWaterRegion3Unit: "",
        powerWaterRegion4: "0010",
        powerWaterRegion4Name: "压力值",
        powerWaterRegion4Unit: "MPa",
        powerWaterState: "0",

        powerMetRegion1Name: '空气温度,空气湿度',
        powerMetRegion1Unit: '℃,%RH',
        powerMetRegion2Name: '土壤温度1,土壤湿度1',
        powerMetRegion2Unit: '℃,%RH',
        powerMetRegion3Name: '光照',
        powerMetRegion3Unit: 'Lux',
        powerMetRegion4Name: 'CO2',
        powerMetRegion4Unit: 'PPM',
        powerMetRegion5Name: '土壤PH1',
        powerMetRegion5Unit: '',
        powerMetRegion6Name: '土壤EC1',
        powerMetRegion6Unit: 'µS/cm',

        powerSoilRegion1Name: '土壤温度1,土壤湿度1',
        powerSoilRegion1Unit: '℃,%RH',
        powerSoilRegion2Name: '土壤温度2,土壤湿度2',
        powerSoilRegion2Unit: '℃,%RH',
        powerSoilRegion3Name: 'PH1',
        powerSoilRegion3Unit: '',
        powerSoilRegion4Name: '土壤EC1',
        powerSoilRegion4Unit: 'µS/cm',
        powerSoilRegion5Name: 'PH2',
        powerSoilRegion5Unit: '',
        powerSoilRegion6Name: '土壤EC2',
        powerSoilRegion6Unit: 'µS/cm',

      }
    };
  },
  mounted() {

    // 从本地缓存中获取数据
    let userInfo = localStorage.getItem("user_info");
    // 将获取到的JSON字符串转换回对象
    this.userInfo = JSON.parse(userInfo);

    this.getPower();


    //查询温室设备统计数据
    this.getWarmDeviceCount();

    //查询园区列表
    this.getParkList();
  },
  methods: {
    getPower() {
      let params = {
        deptId: this.userInfo ? this.userInfo.deptId : 0,
      };

      console.log("params===", params);
      this.$axios
        .get("/power/list", {
          params: params,
        })
        .then((res) => {
          console.log("权限-res===", res.data);
          if (res.data.length != 0) {
            var data = res.data[0];
            this.powerInfo = this.mergeNonNull(this.powerInfo, data);
          }
          localStorage.setItem("power_info", JSON.stringify(this.powerInfo));
        })
        .catch((error) => {
          console.log("权限-error===", error);
        });
    },
    mergeNonNull(target, source) {
      const result = { ...target };
      const isEmpty = (val) => val === null || val === undefined || val === '';

      for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          const srcVal = source[key];
          const tgtVal = target[key];

          if (!isEmpty(srcVal)) {
            if (
              typeof srcVal === 'object' &&
              !Array.isArray(srcVal) &&
              srcVal !== null &&
              typeof tgtVal === 'object' &&
              !Array.isArray(tgtVal) &&
              tgtVal !== null
            ) {
              result[key] = this.mergeNonNull(tgtVal, srcVal);
            } else {
              result[key] = srcVal;
            }
          }
        }
      }
      return result;
    },
    getWarmDeviceCount() {
      let params = {
        deptId: this.userInfo ? this.userInfo.deptId : 0,
      };

      console.log("params===", params);
      this.$axios
        .get("/hothouseDevice/list", {
          params: params,
        })
        .then((res) => {
          console.log("温控-res===", res.data);
          let data = res.data;
          for (let i = 0; i < data.length; i++) {
            if (data[i].hothouseDeviceState == 1) {
              this.warm.up += 1;
            }
            if (data[i].hothouseDeviceState == 2) {
              this.warm.down += 1;
            }
            this.warm.count += 1;
          }
          console.log("温控-count===", this.warm);
          //查询水肥设备统计数据
          this.getWaterDeviceCount();
        })
        .catch((error) => {
          console.log("温控-error===", error);
        });
    },
    getWaterDeviceCount() {
      let params = {
        deptId: this.userInfo ? this.userInfo.deptId : 0,
      };
      console.log("params===", params);
      this.$axios
        .get("/fertilizerDevice/list", {
          params: params,
        })
        .then((res) => {
          console.log("水肥-res===", res.data);
          let data = res.data;
          for (let i = 0; i < data.length; i++) {
            if (data[i].fertilizerDeviceState == 2) {
              this.water.up += 1;
            }
            if (data[i].fertilizerDeviceState == 1) {
              this.water.down += 1;
            }
            this.water.count += 1;
          }
          console.log("水肥-count===", this.water);

          //查询五情设备统计数据
          this.getFiveEmotionsDeviceCount();
        })
        .catch((error) => {
          console.log("水肥-error===", error);
        });
    },
    getFiveEmotionsDeviceCount() {
      let params = {
        deptId: this.userInfo ? this.userInfo.deptId : 0,
      };
      console.log("params===", params);
      this.$axios
        .get("/FourEmotions/GetUserDevice", {
          params: params,
        })
        .then((res) => {
          console.log("五情-res===", res.data);
          let data = res.data;
          // for (let i = 0; i < data.length; i++) {
          // 	let params = {
          // 		deptId: this.userInfo.deptId,
          // 		deviceAddrs: data[i].deviceAddr,
          // 	};
          // 	this.$axios
          // 		.get("/FourEmotions/getRealTimeData", {
          // 			params: params
          // 		})
          // 		.then((re) => {
          // 			if (re.data.length > 0) {
          // 				this.fiveEmotions.up += 1;
          // 			} else {
          // 				this.fiveEmotions.down += 1;
          // 			}
          // 			this.fiveEmotions.count += 1;
          // 		})
          // 		.catch((erro) => {
          // 			console.log("五情设备详情-error===", erro);
          // 		});
          // }
          this.fiveEmotions.count = data.length;
          console.log("五情-count===", this.fiveEmotions);
        })
        .catch((error) => {
          console.log("五情-error===", error);
        });
    },

    getParkList() {
      let params = {
        deptId: this.userInfo ? this.userInfo.deptId : 0,
      };
      this.$axios
        .get("/massif/list", {
          params: params,
        })
        .then((res) => {
          console.log("园区列表-error===", res);
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].massifPic != null) {
              res.data[i].massifPic = res.data[i].massifPic.split(",");
            }
          }
          this.parkList = res.data;
        })
        .catch((error) => {
          console.log("园区列表-error===", error);
        });
    },

    exitOnHandle() {
      this.$confirm("退出系统, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "再想想",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("/user/logout", {
              userId: this.userInfo.userId,
            })
            .then((res) => {
              console.log("退出登录-res===", res);
              localStorage.setItem("user_info", null);
              localStorage.setItem("power_info", null);
              this.$router.replace("/loginPage");
            })
            .catch((error) => {
              console.log("登录-error===", error);
            });
        })
        .catch(() => { });
    },
    nextClick(index) {
      this.current = index;
      if (index < 2) {
        this.dialogVisible = true;
      } else {
        this.$router.push({
          path: "/layout",
          query: {
            current: index,
          },
        });
      }
    },
    handleParkChange() {
      if (this.parkId == null) {
        this.$message({
          message: "请选择您要前往的园区",
          type: "warning",
        });
      } else {
        this.$router.push({
          path: "/layout",
          query: {
            current: this.current,
            parkId: this.parkId,
          },
        });
      }
    },
  },
};
</script>

<style>
.content-center-body-flex {
  background: url("https://baigebackupdata.oss-cn-beijing.aliyuncs.com/zhihuinongye/1704177696543.png");
  background-size: 100% 100%;
  width: 95%;
  position: absolute;
  height: 515px;
  bottom: -195px;
  left: 5%;
}

.index-bg-img {
  width: 100%;
  height: 100%;
  background-image: url("https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702262757012.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: #010c2a;
  text-align: center;
}

.exit {
  cursor: pointer;
  color: #4ff5f7;
  font-size: 1.25rem;
  padding-right: 3%;
  position: absolute;
  top: 60px;
  right: 30px;
}

.grid-content {
  display: flex;
  justify-content: center;
  height: 100%;
}

.tab-bg {
  padding: 1.875rem;
  border-top: 0.0625rem solid;
  border-bottom: 0.0625rem solid;
  border-image: linear-gradient(to left,
      transparent 0%,
      #138dc2 50%,
      transparent 100%) 1;
  background-image: linear-gradient(to left,
      transparent 0%,
      #033855 50%,
      transparent 100%);
  margin-bottom: 3.4375rem;
  /* 11 */
}

.tab-title {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  background: linear-gradient(to left, #025ac4 0%, #00e7ff 50%, #025ac4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.content-center {
  margin-top: 1.5rem;
  width: 100%;
  padding: 1.875rem;
  border: 0.125rem solid #3aceff;
}

.content-center-left-right-icon {
  display: flex;
  justify-content: space-between;
}

.content-center-left-right-icon img {
  width: 2.8125rem;
  height: 1.25rem;
}

.content-center-header {
  display: flex;
  justify-content: space-around;
  margin-top: 1.875rem;
  padding: 2.5rem 1.875rem;
  box-shadow: inset 0 0 2.1875rem #043388;
}

.content-center-header-item {
  width: 30%;
  padding: 0.3125rem;
  background-color: #0b2372;
  border-radius: 0.5rem;
  color: #42e2ec;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  justify-content: center;
}

.content-center-header-item img {
  width: 0.9375rem;
  height: 1.125rem;
  margin-right: 0.625rem;
}

.content-center-header-item-title {
  width: 100%;
  display: flex;
  /* justify-content: space-around; */
  font-weight: 400;
  text-align: center;
  /* zoom: 50%; */
  /* transform: scale(0.5); */
}

.content-center-header-item-title .title1 {
  margin-top: 0.625rem;
  width: 33%;
  color: #42e2ec;
  font-weight: bold;
  font-size: 15px;
}

.content-center-header-item-title .title2 {
  margin-top: 0.625rem;
  width: 33%;
  color: #999;
  font-weight: 400;
  font-size: 14px;
}

.content-center-body {
  margin-top: 0.9375rem;
  display: flex;
  justify-content: center;
}

.content-center-body-center-img img {
  margin-top: 6.9375rem;
  width: 11.5rem;
  padding: 0rem 1.5625rem;
  height: 16rem;
  /* opacity: 0.5; */
}

.content-center-body-left-right-img img {
  margin-top: 1.875rem;
  margin-bottom: 4.6875rem;
  width: 18.75rem;
  height: 6.25rem;
  position: relative;
  top: 56px;
  /* opacity: 0.5; */
}

.v-modal {
  background-color: transparent;
  position: relative;
  top: -999999;
}

.el-dialog {
  border-radius: 5px;
  background-color: #03112b;
  background-image: url("https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701242806066.png");
  background-size: 100% 100%;
  color: #fff;
  border-left: 2px solid #00e7ff;
  border-right: 2px solid #00e7ff;
  border-bottom: 2px solid #00e7ff;
}

.el-dialog__wrapper {
  position: fixed;
  top: 6%;
}

.el-dialog__title {
  color: #fff;
}

.dialog-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: auto;
}

.dialog-content-body {
  width: 100%;
  height: 33.75rem;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.dialog-content-body::-webkit-scrollbar {
  width: 0.5rem;
  background-color: transparent;
}

.dialog-content-body::-webkit-scrollbar-thumb {
  background-color: transparent;
}

.dialog-item-bg {
  width: 85%;
  height: 16.25rem;
  margin: 0.8125rem;
  border: 0.125rem solid #999;
  border-radius: 0.3125rem;
  cursor: pointer;
}

.dialog-item-bg-sel {
  width: 85%;
  height: 16.25rem;
  margin: 0.8125rem;
  background-image: url("https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701239983724.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

.dialog-content-title {
  text-align: center;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #fff;
}
</style>
